/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownSpecialStatus } from '../models/db_DropdownSpecialStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SpecialStatuses {
    /**
     * Get a list of special statuses
     * @returns db_DropdownSpecialStatus OK
     * @throws ApiError
     */
    public static listSpecialStatuses(): CancelablePromise<Array<db_DropdownSpecialStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/special-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
